module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9r7uz"))).then(() => parcelRequire('ikE14'));